// extracted by mini-css-extract-plugin
module.exports = {"footer":"CVMFooter_footer__T9ffx","root":"CVMFooter_root__jfCJA"};